import { useParams, Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { articles } from "@/mocks/articles";
import ArticleCard from "@/components/base/ArticleCard";
import Breadcrumb from "@/components/base/Breadcrumb";
import SEOHead from "@/components/base/SEOHead";
import SchemaOrg from "@/components/base/SchemaOrg";
import NotFound from "@/pages/NotFound";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);

  if (!category) {
    return <NotFound />;
  }

  const categoryArticles = articles.filter((a) => a.category === slug);

  const categoryNameMap: Record<string, string> = {
    "plot-analysis": "剧情解析",
    reviews: "观后感",
    education: "教育意义",
    "character-analysis": "角色分析",
    "spelling-bee": "拼写比赛",
    inspiration: "励志成长",
  };

  return (
    <>
      <SEOHead
        title={`${category.name} - 分类浏览`}
        description={category.description}
        canonicalUrl={`https://akeelah-guide.com/category/${slug}`}
      />
      <SchemaOrg type="category" categorySlug={slug} />

      <main className="pt-20">
        <div className="bg-background-100 border-b border-background-200/70">
          <div className="w-full px-4 md:px-6 py-8">
            <Breadcrumb
              items={[
                { label: "首页", href: "/" },
                { label: category.name },
              ]}
            />
            <div className="mt-4">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                  <i className={`${category.icon} text-lg`}></i>
                </div>
                <h1 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
                  {category.name}
                </h1>
              </div>
              <p className="text-sm md:text-base text-foreground-600 ml-13 pl-0">
                {category.description}
              </p>
            </div>
          </div>
        </div>

        <div className="w-full px-4 md:px-6 py-8">
          <div className="flex items-center gap-2 mb-6 flex-wrap">
            <span className="text-xs text-foreground-500 font-medium">全部分类：</span>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  cat.slug === slug
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-600 hover:bg-background-200"
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          {categoryArticles.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {categoryArticles.map((article) => (
                <ArticleCard key={article.slug} article={article} variant="default" />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100 text-foreground-400">
                <i className="ri-inbox-line text-2xl"></i>
              </div>
              <p className="text-foreground-500">该分类下暂无文章</p>
            </div>
          )}
        </div>
      </main>
    </>
  );
}